import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody, Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import PreventiveTaskProjectionAreaViewField from './PreventiveTaskProjectionAreaViewField';
import PreventiveTaskProjectionDepartmentViewField from './PreventiveTaskProjectionDepartmentViewField';

const PreventiveTaskProjectionSearchForm = ({ handleSubmit, loading }) => (
  <Card className="mb-3">
    <CardBody>
      <Form onSubmit={handleSubmit}>
        <FormGroup row>
          <FormItem label="Proyección">
            <Field
              name="daysToAdd"
              component={TextInput}
              type="number"
              placeholder="número de días a proyectar (ej: 30)"
            />
          </FormItem>
        </FormGroup>

        <FormGroup row>
          <FormItem label="Vista">
            <div>
              <Label className="mr-3">
                <Field
                  name="view"
                  component="input"
                  type="radio"
                  value="USER"
                />{' '}
                Mis tareas
              </Label>

              <PreventiveTaskProjectionAreaViewField />

              <PreventiveTaskProjectionDepartmentViewField />
            </div>
          </FormItem>
        </FormGroup>

        <FormFooter
          saveButtonDisabled={loading}
          saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-search'}
          saveButtonText="Buscar"
        />
      </Form>
    </CardBody>
  </Card>
);

PreventiveTaskProjectionSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

PreventiveTaskProjectionSearchForm.defaultProps = {
  loading: false,
};

export default reduxForm({
  form: 'PreventiveTaskProjectionSearchForm',
  enableReinitialize: true,
})(PreventiveTaskProjectionSearchForm);
